import { GET_HELP_MESSAGE } from './action';

const initState = {

};
const reducer = (state = initState, action) => {
    switch (action.type) {
        case GET_HELP_MESSAGE: 
            return {
                ...state,
                ...action.data
            };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/views/Help/state/reducer.js